"use client";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Stack,
} from "@chakra-ui/react";
import { JobsSectionPosting, PageBlockJobsSection } from "lib/gcms";

export default function JobsSection({
  description,
  equalOpportunityText,
  noJobsText,
  jobPostings,
  bg,
  color,
}: PageBlockJobsSection) {
  jobPostings = jobPostings || [];
  return (
    <Box as="section" bg={bg} color={color} px={{ base: "6", md: "8" }} py="12">
      <Stack
        maxW="2xl"
        mx="auto"
        spacing={{
          base: "6",
          lg: "12",
        }}
        textAlign="center"
        alignItems="center"
      >
        <a id="careers" />
        <Heading
          as="h2"
          fontSize={{
            base: 26,
            md: 34,
            lg: 38,
            xl: 45,
          }}
          fontWeight="bold"
          letterSpacing="tight"
        >
          Careers
        </Heading>
        <Box
          sx={{
            p: {
              fontSize: "lg",
            },
          }}
        >
          {description}
        </Box>
        {jobPostings.length > 0 ? (
          <>
            <Heading as="h2" size="xl" fontWeight="extrabold" key="heading">
              Current Openings
            </Heading>
            <Accordion allowToggle w="full">
              {jobPostings.map((posting, idx) => jobPosting(posting, idx))}
            </Accordion>
          </>
        ) : (
          <Box
            sx={{
              p: {
                color: "gray.400",
                fontSize: "xl",
              },
            }}
          >
            {noJobsText}
          </Box>
        )}
        <Box
          sx={{
            p: {
              color: "gray.400",
              fontSize: "xl",
            },
          }}
        >
          {equalOpportunityText}
        </Box>
      </Stack>
    </Box>
  );
}

const jobPosting = (posting: JobsSectionPosting, idx: number) => (
  <AccordionItem key={idx} textAlign="left">
    <h2>
      <AccordionButton
        _expanded={{
          fontWeight: "bold",
          bg: "blueGray.50",
        }}
        _focus={{
          outline: "none",
        }}
        _hover={{
          bg: "blueGray.50",
        }}
      >
        <Box flex="1" textAlign="left" fontSize="lg">
          {posting.jobTitle}
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel>{posting.jobDescription}</AccordionPanel>
  </AccordionItem>
);
